module.exports = __webpack_public_path__ + "media/flags/ua-1013f48f.svg";